// src/schedule/leave-guard.js
//
// v129.62 — the AI-rota publish guard (FOLLOWUPS ⭐ top item, pay-critical).
//
// publishAiRota used to overwrite WHATEVER row a day already held — including
// booked leave. A manager generates a fresh week, hits publish, and someone's
// approved holiday silently becomes a work shift: the rota lies, and the
// balance ledgers drift from the rota that pays people.
//
// The rule: a day whose EXISTING row is a leave type is never overwritten by
// an AI publish — it is SKIPPED and REPORTED, never silently dropped. 'toil'
// is protected too: a booked TOIL day already carries a ledger deduction, so
// overwriting it with 'work' would orphan that transaction.
//
// Zero-dep and pure so the behaviour is directly testable; the schedule
// bundle imports it, tests import this file straight.

export const PROTECTED_LEAVE_TYPES = ['holiday', 'sick', 'apl', 'toil'];

// Is this existing in-memory rota cell a booked-leave day?
export function isProtectedLeave(existing) {
  return !!(existing && PROTECTED_LEAVE_TYPES.indexOf(existing.type) !== -1);
}

// One human-readable line for the publish report. skipped: [{name, day, type}]
export function skippedSummary(skipped) {
  const L = Array.isArray(skipped) ? skipped : [];
  if (!L.length) return '';
  return 'Kept ' + L.length + ' booked leave day' + (L.length === 1 ? '' : 's') + ' (not overwritten): ' +
    L.map((s) => s.name + ' ' + s.day + ' (' + s.type + ')').join(', ');
}

// v136.8 (16 Oct audit) - Add cover saves with the leave guard on. The Worker keeps a booked-leave day back
// (src/worker/leave-guard-server.js) and returns only the rows it actually saved, so the days it kept are the
// sent days missing from that answer. sent: the rows posted; saved: what DB.shifts.save resolved with.
// An answer that is not a list says nothing about what was kept, so nothing is reported kept.
export function keptBackDays(sent, saved) {
  if (!Array.isArray(saved)) return [];
  const got = new Set(saved.filter(Boolean).map((r) => String(r.staff_id) + '|' + String(r.day)));
  const out = [];
  (Array.isArray(sent) ? sent : []).forEach((r) => {
    if (!r) return;
    if (!got.has(String(r.staff_id) + '|' + String(r.day)) && out.indexOf(r.day) === -1) out.push(r.day);
  });
  return out;
}

// The plain-words refusal for a cover save that met booked leave.
export function coverLeaveMessage(firstName, keptDays, placedCount) {
  const days = (Array.isArray(keptDays) ? keptDays : []).join(', ');
  const n = Number(placedCount) || 0;
  return firstName + ' has booked leave on ' + days + ', so those days were not changed.' +
    (n > 0 ? ' Added as cover for the other ' + n + ' day' + (n === 1 ? '' : 's') + '.' : ' No cover was added.');
}
